export function track(event, params) {
    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', event, params);
        }
    }
    catch {
        // Telemetry must never break UX.
    }
}
